import {
  TMenuLink,
  TTemplate,
} from "../../@types/Entities/TWhiteLabelGroupEntity";
import { TGlobalState } from "../../@types/State/TGlobalState";
import {
  TGetWhiteLabelGroupsState,
  TWhiteLabelGroupState,
} from "../../@types/State/TWhiteLabelGroupState";

export const whiteLabelGroupSelector = (
  state: TGlobalState
): TWhiteLabelGroupState => {
  return state.whiteLabelGroup;
};

export const getWhiteLabelGroupsSelector = (
  state: TGlobalState
): TGetWhiteLabelGroupsState =>
  whiteLabelGroupSelector(state).getWhiteLabelGroup;

export const menuLinksWhiteLabelGroupSelector = (
  state: TGlobalState
): TMenuLink[] =>
  getWhiteLabelGroupsSelector(state).data?.menuLinks as TMenuLink[];

export const templateWhiteLabelGroupSelector = (
  state: TGlobalState
): TTemplate => getWhiteLabelGroupsSelector(state).data?.template as TTemplate;
